<template>
  <el-table-column
    prop="cash_comment"
    label="Kp. megjegyzés"
    show-overflow-tooltip
    min-width="200"
  >
    <template slot-scope="scope">
      {{ scope.row.cash_comment }}
    </template>
  </el-table-column>
</template>
<script>
  export default {
    propName: 'cash_comment',
  };
</script>
